import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e67bc1ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "training-index" }
const _hoisted_2 = {
  key: 0,
  class: "el-carousel el-carousel--horizontal training-index-carousel"
}
const _hoisted_3 = { class: "el-carousel__container" }
const _hoisted_4 = {
  class: "el-carousel__item is-active is-animating",
  style: {"background-color":"#FFFFFF"}
}
const _hoisted_5 = { class: "fd-center" }
const _hoisted_6 = { class: "training-index-periods" }
const _hoisted_7 = { class: "training-index-periods-box" }
const _hoisted_8 = { class: "training-index-periods-box-content" }
const _hoisted_9 = { class: "training-index-periods-box-lt" }
const _hoisted_10 = { class: "training-index-periods-box-lt-title" }
const _hoisted_11 = { class: "training-index-periods-box-lt-name" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode()
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "training-index-periods-box-lt-label" }
const _hoisted_15 = { class: "training-index-periods-box-lt-label" }
const _hoisted_16 = { class: "training-index-periods-box-lt-label" }
const _hoisted_17 = { class: "training-index-periods-box-rt" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "本期培训增设2处现场体验环节，请各位学员带齐用具准时前往，在入口处按指引操作，有疑问可随时联系现场导师。", -1))
const _hoisted_19 = { class: "training-index-periods-btn" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("立即抢占")
const _hoisted_21 = {
  key: 0,
  class: "training-index-periods-nums"
}
const _hoisted_22 = { class: "training-index-tn" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "training-index-tn-title",
  id: "training-1"
}, "全国巡回培训计划", -1))
const _hoisted_24 = { class: "training-index-tn-box" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "training-index-tn-lt" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "chinaMapChart",
    style: {"width":"780px","height":"600px"}
  })
], -1))
const _hoisted_26 = { class: "training-index-tn-rt" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "training-index-tn-rt-title" }, "最新培训计划", -1))
const _hoisted_28 = { class: "training-index-tn-rt-box" }
const _hoisted_29 = { class: "training-index-tn-rt-list" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "training-index-tn-rt-name" }
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { key: 3 }
const _hoisted_34 = {
  key: 0,
  class: "training-index-tn-rt-nums"
}
const _hoisted_35 = { class: "training-index-tn-rt-adress" }
const _hoisted_36 = { class: "training-index-tn-rt-time" }
const _hoisted_37 = {
  key: 1,
  class: "training-index-tn-rt-status status3",
  style: {"display":"none"}
}
const _hoisted_38 = {
  key: 2,
  class: "training-index-tn-rt-status status4",
  style: {"display":"none"}
}
const _hoisted_39 = {
  key: 3,
  class: "training-index-tn-rt-status status5",
  style: {"display":"none"}
}
const _hoisted_40 = {
  key: 4,
  class: "training-index-tn-rt-status status6",
  style: {"display":"none"}
}
const _hoisted_41 = { class: "training-index-before" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "training-index-before-title",
  id: "training-2"
}, "往期培训", -1))
const _hoisted_43 = { class: "training-index-before-box" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "training-index-before-banner" }
const _hoisted_46 = { class: "training-index-before-list" }
const _hoisted_47 = { class: "training-index-before-line" }
const _hoisted_48 = {
  key: 0,
  class: "training-index-before-nums"
}
const _hoisted_49 = {
  key: 1,
  class: "training-index-before-nums"
}
const _hoisted_50 = { class: "training-index-before-address" }
const _hoisted_51 = { class: "training-index-before-line" }
const _hoisted_52 = {
  key: 0,
  class: "training-index-before-name"
}
const _hoisted_53 = {
  key: 1,
  class: "training-index-before-name"
}
const _hoisted_54 = { class: "training-index-before-time" }
const _hoisted_55 = { class: "training-index-query" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode("拎包培训证书查询 ")
const _hoisted_57 = /*#__PURE__*/_createTextVNode("拎包入住知识线上自测 ")
const _hoisted_58 = { class: "createOrUpdateMember" }
const _hoisted_59 = { class: "dialog-footer" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_61 = { class: "createOrUpdateMember" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode("在线测试")

import store from "@/store/index";
import { useStore } from '@/store/index';
import { reactive, ref, onMounted, onBeforeUnmount } from "vue";
import Bottom from "../components/bottom.vue";
import Happy from "../components/happy.vue";
import router from "@/router/index";
//import chinaMap from "@/assets/echart/json/china.json";

import * as echarts from 'echarts';
// import 'echarts/map/js/china.js';


interface ActivityVo {
  id: string;
  name: string;
  status: number;
  type: number;
  statusName: string;
  roomNumberName: string;
  deliveryDateString: string;
  decorateTypeName: string;
  thumbnailUrl: string;
  projectName: string;
  companyName: string;
  province: string;
  city: string;
  area: string;
  address: string;
  contact: string;
  mobile: string;
  lessonName: string;
  startTimeString: string;
  endTimeDateString: string;
  remainApplyNumber: number;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ustore = useStore();

const tabActivitys: ActivityVo[] = [];
const historyActivitys: ActivityVo[] = [];
const provincesDefault = [
  { name: "北京市", value: 0 },
  { name: "天津市", value: 0 },
  { name: "上海市", value: 0 },
  { name: "重庆市", value: 0 },
  { name: "河北省", value: 0 },
  { name: "河南省", value: 0 },
  { name: "云南省", value: 0 },
  { name: "辽宁省", value: 0 },
  { name: "黑龙江省", value: 0 },
  { name: "湖南省", value: 0 },
  { name: "安徽省", value: 0 },
  { name: "山东省", value: 0 },
  { name: "新疆维吾尔自治区", value: 0 },
  { name: "江苏省", value: 0 },
  { name: "浙江省", value: 0 },
  { name: "江西省", value: 0 },
  { name: "湖北省", value: 0 },
  { name: "广西壮族自治区", value: 0 },
  { name: "甘肃省", value: 0 },
  { name: "山西省", value: 0 },
  { name: "内蒙古自治区", value: 0 },
  { name: "陕西省", value: 0 },
  { name: "吉林省", value: 0 },
  { name: "福建省", value: 0 },
  { name: "贵州省", value: 0 },
  { name: "广东省", value: 0 },
  { name: "青海省", value: 0 },
  { name: "西藏自治区", value: 0 },
  { name: "四川省", value: 0 },
  { name: "宁夏回族自治区", value: 0 },
  { name: "海南省", value: 0 },
  { name: "台湾省", value: 0 },
  { name: "香港特别行政区", value: 0 },
  { name: "澳门特别行政区", value: 0 }
];

const bindData = reactive({
  activityId: '',
  isShowDefaultImage: true,
  defaultImage: "",
  images: [],
  activity: {
    id: '',
    name: '',
    status: 1,
    type: '',
    statusName: '',
    roomNumberName: '',
    deliveryDateString: '',
    decorateTypeName: '',
    thumbnailUrl: '',
    projectName: '',
    companyName: '',
    province: '',
    city: '',
    area: '',
    address: '',
    contact: '',
    mobile: '',
    lessonName: '',
    startTimeString: '',
    endTimeDateString: '',
    remainApplyNumber: 0
  },
  tabActivitys: tabActivitys,
  historyActivitys: historyActivitys,
  testFormData: {
    studentCode: '2022051800112121',
    studentName: '杨洋',
    lessonName: '第19期 拎包入住精英训练营',
    testName: '结业考试',
    testTime: 120,
    testWay: '闭卷',
    testRequest: '请保持考试纪律，不得交头接耳。不得携带和使用电子设备，发现作弊者，取消考试成绩，并公示处罚。',
  },
  loginMember: ustore.state.loginMember == undefined ? {} : ustore.state.loginMember,
  isLogin: ustore.state.loginMember == undefined ? false : true,
  provinces: provincesDefault,
  provinceSearch: '',
  tabIndex: 0,
  onlineExams:[],
});

const advertisingImageEvent = () => {
  store.dispatch("frontIndexModule/listAdvertisingImage", { type: 3 }).then(
    (data) => {
      console.log(data.result);
      bindData.images = data.result;
      if (data.result.length > 0) {
        bindData.defaultImage = data.result[0];
      }
    },
    (error) => {
      console.log(error.msg);
    }
  );
};


const activeName = ref('拎包入住精英训练营')
const tabs = ref([
  {
    id: 1,
    name: '拎包入住精英训练营'
  },
  {
    id: 2,
    name: '拎包入住私享会'
  }
])

const handleToDetail = (id: string) => {
  router.push('/frontDesk/trainingIndex/trainingDetail/' + id)
}

advertisingImageEvent();

const loadTabActivitys = (type: any) => {
  store.dispatch("frontTrainingModule/listActivity", {
    type: type,
    limit: 6,
    province: bindData.provinceSearch
  })
    .then(
      (data) => {
        bindData.tabActivitys = data.result;
      },
      (error) => {
        console.log(error.msg);
      }
    );
}


const listOnlineExam = () => {
  store.dispatch("frontTrainingModule/listOnlineExam", {
  })
    .then(
      (data) => {
        bindData.onlineExams = data.result;
      },
      (error) => {
        console.log(error.msg);
      }
    );
}
listOnlineExam();

const toOnlineExam = (row:any) =>{
   window.open(row.website);
}

const tabHandleClick = (tab: any, event: Event) => {
  bindData.tabIndex = tab.index;
  if (tab.index == 0) {
    //培训活动
    loadTabActivitys(4);
  } else {
    //私享会活动
    loadTabActivitys(6);
  }
  provinceEvent();
};

loadTabActivitys(4);

//往期活动
store.dispatch("frontTrainingModule/listActivity", {
  types: '4,6',
  status: 6,
  limit: 6,
})
  .then(
    (data) => {
      bindData.historyActivitys = data.result;
    },
    (error) => {
      console.log(error.msg);
    }
  );
//当前活动：正在报名
const loadCurrActivity = (type: any, status: any, number: number) => {
  store.dispatch("frontTrainingModule/listActivity", {
    type: type,
    status: status,
    limit: 1,
  })
    .then(
      (data) => {
        if (data.result != null && data.result.length > 0) {
          bindData.activity = data.result[0];
          bindData.activityId = data.result[0].id;
        }
        else {
          switch (number) {
            case 1:
              //私享会, 正在报名
              loadCurrActivity(6, 4, number + 1);
              break;
            case 2:
              //培训, 即将开始
              loadCurrActivity(4, 3, number + 1);
              break;
            case 3:
              //私享会, 即将开始
              loadCurrActivity(6, 3, number + 1);
              break;
            case 4:
              //培训, 已开始
              loadCurrActivity(4, 5, number + 1);
              break;
            case 5:
              //私享会, 已开始
              loadCurrActivity(6, 5, number + 1);
              break;
            case 6:
              //培训, 已结束
              loadCurrActivity(4, 6, number + 1);
              break;
            case 7:
              //私享会, 已结束
              loadCurrActivity(6, 6, number + 1);
              break;
            default:
              break;
          }
        }
      },
      (error) => {
        console.log(error.msg);
      }
    );
}
//培训, 正在报名
loadCurrActivity(4, 4, 1);

const provinceEvent = () => {
  var selectType = 0;
  if (bindData.tabIndex == 0) {
    //培训活动
    selectType = 4;
  } else {
    //私享会活动
    selectType = 6;
  }
  store.dispatch("frontTrainingModule/listActivityProvince", { type: selectType }).then(
    (data) => {
      const list = data.result;
      let myMap = new Map();
      for (let index in list) {
        myMap.set(list[index].province, list[index].count);
      }
      const dataList = new Array<any>();
      for (let index in provincesDefault) {
        const obj = provincesDefault[index];
        const name = obj.name;
        var value = obj.value;
        var newValue = myMap.get(name);
        if (newValue == null) {
          newValue = myMap.get(name.replace("省", "").replace("市", ""))
        }
        if (newValue != null && newValue > 0) {
          value = newValue;
        }
        dataList.push({
          name: name,
          value: value
        });
      }
      bindData.provinces = dataList;

      initEcharts();
      //屏幕大小自适应，重置容器高宽
      //resizeMainContainer();
      window.addEventListener('resize', eventListener);

      chinaMapChart.off('click');
      chinaMapChart.on('click', (param: any) => {
        if (param.data.value <= 0) {
          return;
        }
        bindData.provinceSearch = param.data.name;
        if (bindData.tabIndex == 0) {
          //培训活动
          loadTabActivitys(4);
        } else {
          //私享会活动
          loadTabActivitys(6);
        }
      });
    },
    (error) => {
      console.log(error.msg);
    }
  );
};



const certificateDialogVisible = ref(false);

const certificateHandleCloseEvent = (done: () => void) => {
  done();
};

const testDialogVisible = ref(false);

const testHandleCloseEvent = (done: () => void) => {
  done();
};

setTimeout(() => {
  bindData.isShowDefaultImage = false;
}, 3000);

const chinaMapChartId = 'chinaMapChart';
let chinaMapChart: any = null;

const initEcharts = () => {
    const mainContainer: any = document.getElementById(chinaMapChartId);
    debugger;
    let chinaMap = require('@/assets/echart/json/china.json');
    echarts.registerMap("china", { geoJSON: chinaMap });

    var resizeMainContainer = function () {
      mainContainer.style.width = '780px';
      mainContainer.style.height = '600px';
    };
    //设置div容器高宽
    resizeMainContainer();

    mainContainer.removeAttribute("_echarts_instance_");

    chinaMapChart = echarts.init(mainContainer);
    chinaMapChart.setOption({
      backgroundColor: "#FFFFFF",
      title: {
        text: "",
        subtext: "",
        x: "center"
      },
      tooltip: {
        trigger: "item",
        formatter: function (params: any) {
          if (!params.value || params.value == undefined || params.value == null || params.value == '-') {
            return '&nbsp;&nbsp;&nbsp;省份：' + params.name + '<br/>' + '活动数：' + '暂无数据';
          } else {
            return '&nbsp;&nbsp;&nbsp;省份：' + params.name + '<br/>' + '活动数：' + params.value;
          }
        }
      },

      //左侧小导航图标
      visualMap: {
        orient: 'horizontal',
        x: '5%',
        min: 0,
        max: 1,
        hoverLink: false,
        text: ["高", "低"],
        inRange: {
          color: [
            '#F2F2F2',
            '#313695',
          ]
        },
      },

      //配置属性
      series: [
        {
          name: "活动数",
          type: "map",
          map: "china", // ---此处是中国地图样式-------需要注意：省份中应使用汉字即如 ‘mapType:"河南"’
          zoom: 1.2,
          roam: true,
          emphasis: {
            label: {
              show: true
            }
          },
          selectedMode: 'single',
          data: bindData.provinces//数据
        }
      ]
    });
};

const eventListener = () => {
  if (chinaMapChart) {
    chinaMapChart.resize();
  }
};

onMounted(() => {
  provinceEvent();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', eventListener);
});

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(bindData).isShowDefaultImage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_image, {
                class: "training-index-carousel-banner",
                src: _unref(bindData).defaultImage
              }, null, 8, ["src"])
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(_component_el_carousel, {
          key: 1,
          class: "training-index-carousel"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).images, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, {
                key: index,
                style: {"background-color":"#FFFFFF"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_image, {
                    class: "training-index-carousel-banner",
                    src: item
                  }, null, 8, ["src"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_image, {
            class: "training-index-periods-box-bg",
            src: require('@/assets/fd/training/u5634.png')
          }, null, 8, ["src"]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createTextVNode(_toDisplayString(_unref(bindData).activity.name) + " ", 1),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(bindData).activity.lessonName), 1),
                _hoisted_12,
                (_unref(bindData).activity.status == 4)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "现正报名"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_14, "时间：" + _toDisplayString(_unref(bindData).activity.startTimeString) + " ~ " + _toDisplayString(_unref(bindData).activity.endTimeDateString), 1),
              _createElementVNode("div", _hoisted_15, "地点：" + _toDisplayString(_unref(bindData).activity.province) + "." + _toDisplayString(_unref(bindData).activity.city) + "." + _toDisplayString(_unref(bindData).activity.area) + " " + _toDisplayString(_unref(bindData).activity.address), 1),
              _createElementVNode("div", _hoisted_16, "咨询：" + _toDisplayString(_unref(bindData).activity.contact) + _toDisplayString(_unref(bindData).activity.mobile), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_el_image, {
                class: "training-index-periods-box-rt-icon",
                src: require('@/assets/fd/training/u5854.png')
              }, null, 8, ["src"]),
              _hoisted_18
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (handleToDetail(_unref(bindData).activity.id)))
          }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          })
        ]),
        (_unref(bindData).activity.status == 4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, " 剩余" + _toDisplayString(_unref(bindData).activity.remainApplyNumber) + "席", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_el_tabs, {
                modelValue: activeName.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeName).value = $event)),
                class: "demo-tabs",
                onTabClick: tabHandleClick
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_tab_pane, {
                      key: item.id,
                      label: item.name,
                      name: item.name
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_29, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).tabActivitys, (activity) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "training-index-tn-rt-line",
                              key: activity.id
                            }, [
                              _createElementVNode("div", {
                                onClick: ($event: any) => (handleToDetail(activity.id))
                              }, [
                                _createElementVNode("div", _hoisted_31, [
                                  (activity.type == 4)
                                    ? (_openBlock(), _createBlock(_component_el_image, {
                                        key: 0,
                                        class: "training-index-tn-rt-name-icon",
                                        src: require('@/assets/fd/training/u5868.png')
                                      }, null, 8, ["src"]))
                                    : (_openBlock(), _createBlock(_component_el_image, {
                                        key: 1,
                                        class: "training-index-tn-rt-name-icon",
                                        src: require('@/assets/fd/training/u5870.png')
                                      }, null, 8, ["src"])),
                                  (activity.type == 4)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(activity.lessonName), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(activity.name), 1))
                                ]),
                                (activity.type == 4)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(activity.name), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_35, _toDisplayString(activity.province) + "." + _toDisplayString(activity.city), 1),
                                _createElementVNode("div", _hoisted_36, _toDisplayString(activity.startTimeString) + " ~ " + _toDisplayString(activity.endTimeDateString), 1),
                                (activity.status == 3)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(activity.statusName), 1))
                                  : (activity.status == 4)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(activity.statusName), 1))
                                    : (activity.status == 5)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(activity.statusName), 1))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(activity.statusName), 1))
                              ], 8, _hoisted_30)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "name"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _hoisted_42,
        _createElementVNode("div", _hoisted_43, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).historyActivitys, (activity) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "training-index-before-item",
              key: activity.id
            }, [
              _createElementVNode("div", {
                onClick: ($event: any) => (handleToDetail(activity.id))
              }, [
                _createElementVNode("div", _hoisted_45, [
                  _createVNode(_component_el_image, {
                    fit: "fill",
                    src: activity.thumbnailUrl
                  }, null, 8, ["src"])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    (activity.type == 4)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(activity.name), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_49)),
                    _createElementVNode("div", _hoisted_50, _toDisplayString(activity.province) + "." + _toDisplayString(activity.city), 1)
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    (activity.type == 4)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(activity.lessonName), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(activity.name), 1)),
                    _createElementVNode("div", _hoisted_54, _toDisplayString(activity.startTimeString) + " ~ " + _toDisplayString(activity.endTimeDateString), 1)
                  ])
                ])
              ], 8, _hoisted_44)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_55, [
        _createVNode(_component_el_input, {
          class: "training-index-query-ipt",
          placeholder: "请输入学员编号"
        }),
        _createVNode(_component_el_button, {
          class: "training-index-query-btn",
          type: "danger",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (certificateDialogVisible.value = true))
        }, {
          default: _withCtx(() => [
            _hoisted_56
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "training-index-query-btn",
          type: "primary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (testDialogVisible.value = true)),
          style: {"width":"200px"}
        }, {
          default: _withCtx(() => [
            _hoisted_57
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(Happy, {
      class: "training-index-happy",
      activityId: _unref(bindData).activityId,
      id: "training-3"
    }, null, 8, ["activityId"]),
    _createVNode(Bottom),
    _createVNode(_component_el_dialog, {
      modelValue: certificateDialogVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((certificateDialogVisible).value = $event)),
      title: "证书查询结果",
      width: "40%",
      "before-close": certificateHandleCloseEvent
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_59, [
          (_unref(bindData).isLogin)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.alert('下载中!')))
              }, {
                default: _withCtx(() => [
                  _hoisted_60
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_58, [
          (_unref(bindData).isLogin)
            ? (_openBlock(), _createBlock(_component_el_image, {
                key: 0,
                src: require('@/assets/fd/training/certificate_bg.png')
              }, null, 8, ["src"]))
            : (_openBlock(), _createBlock(_component_el_image, {
                key: 1,
                src: require('@/assets/fd/training/certificate_example.png')
              }, null, 8, ["src"]))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: testDialogVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((testDialogVisible).value = $event)),
      title: "考试入口",
      width: "42%",
      "before-close": testHandleCloseEvent
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_61, [
          _createVNode(_component_el_table, {
            data: _unref(bindData).onlineExams,
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "name",
                label: "试卷",
                width: "200"
              }),
              _createVNode(_component_el_table_column, {
                prop: "questionNumber",
                label: "题目数量",
                width: "150"
              }),
              _createVNode(_component_el_table_column, {
                prop: "examTime",
                label: "时长",
                width: "150"
              }),
              _createVNode(_component_el_table_column, {
                fixed: "right",
                label: "操作",
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    type: "text",
                    size: "small",
                    onClick: ($event: any) => (toOnlineExam(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_62
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})